import styled from 'styled-components';
import { devices } from '../../utilities/responsive';

export const Tags = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5% 0 5% 0;
    

    &:last-child {
        align-self: flex-end;
    }

    .category {
        padding: 5px 10px;
        background: var(--primary);
        border-radius: 100px;
        font-size: 1.2rem;
        margin: 4px 2px 4px 0;
        color: var(--white);

        @media ${devices.phoneLg} {
            margin: 4px 2px;
            font-size: 1.4rem;
        } 

        &:hover {
            background-color: #546cf7;
            color: var(--white);
        }

        &.category--news {
            background-color: var(--eyebrow-color);

            &:hover {
            }
        }

        &.category-technology {
            background-color: var(--heavenly);

            &:hover {
                background-color: #17a5eb;
            }
        }

        &.category-digital {
            background-color: var(--azure);

            &:hover {
               background-color: #4068ff;
            }
        }
    }

    .tags {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        line-height: 1.5;
        font-weight: 600;

        @media ${devices.phoneLg} {
            margin-top: 5px;
        } 

        a.tag {
            padding: 0 3px;
            color: var(--green);
            font-size: 1.6rem;
            letter-spacing: .2px;
            font-weight: 400;
            margin: 3px;

            &.active {
                background-color: var(--primary);
                color: var(--white);
                border: none;
                
                &:hover {
                    color: var(--white);
                    border: none;
                }
            }

            &:hover {
                color: var(--primary);
            }
        }
    }
`;

export const Link = styled.a`
    padding: 5px 16px 5px 16px !important;
    background: rgba(32, 152, 177, 0.2);
     font-family: 'Nunito sans', sans-serif;
     font-weight: 800;
      color: #5062CD !important;
     border-radius: 25px;
     font-size: 1.5rem;
     margin: 3px;
     cursor: pointer;
`